import React, { useState, useEffect } from "react";
import { Phone, Menu, X, ChevronDown } from "lucide-react";
import { Button } from "../components/ui/button";
import { services } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { label: "HOME", id: "home" },
    { label: "ABOUT US", id: "about" },
    { label: "SERVICES", id: "services", hasDropdown: true },
    { label: "PROJECTS", id: "projects" },
    { label: "REVIEWS", id: "reviews" },
    { label: "CONTACT", id: "contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-brand-dark/95 backdrop-blur-md shadow-lg" : "bg-brand-dark"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <button onClick={() => scrollTo("home")} className="flex items-center group py-2">
            <img
              src="https://customer-assets-gfyr7b9c.emergentagent.net/job_design-build-live-1/artifacts/pt3xqgqe_file_000000007bb48210bf689d869ac39baf_GEoBTL.png"
              alt="KJ Ground Force - Groundworks & Landscaping"
              className="h-16 md:h-20 w-auto object-contain group-hover:scale-105 transition-transform duration-300 drop-shadow-lg"
            />
          </button>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <div
                key={link.id}
                className="relative"
                onMouseEnter={() => link.hasDropdown && setServicesOpen(true)}
                onMouseLeave={() => link.hasDropdown && setServicesOpen(false)}
              >
                <button
                  onClick={() => scrollTo(link.id)}
                  className="text-white text-[13px] font-semibold tracking-wider hover:text-brand-yellow transition-colors flex items-center gap-1"
                >
                  {link.label}
                  {link.hasDropdown && <ChevronDown size={14} />}
                </button>
                {link.hasDropdown && servicesOpen && (
                  <div className="absolute top-full left-1/2 -translate-x-1/2 pt-4 w-64">
                    <div className="bg-brand-dark-2 border border-brand-yellow/20 rounded-md shadow-xl overflow-hidden">
                      {services.map((s) => (
                        <button
                          key={s.id}
                          onClick={() => scrollTo("services")}
                          className="block w-full text-left px-5 py-3 text-white text-xs font-semibold tracking-wide hover:bg-brand-yellow hover:text-brand-dark transition-colors border-b border-white/5 last:border-0"
                        >
                          {s.title}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* Right side */}
          <div className="hidden lg:flex items-center gap-5">
            <a
              href="tel:07784732546"
              className="flex items-center gap-2 text-white hover:text-brand-yellow transition-colors"
            >
              <div className="w-9 h-9 rounded-full border border-brand-yellow/60 flex items-center justify-center">
                <Phone size={14} className="text-brand-yellow" />
              </div>
              <span className="text-sm font-bold tracking-wide">07784 732546</span>
            </a>
            <Button
              onClick={() => scrollTo("contact")}
              className="bg-brand-yellow hover:bg-brand-yellow-dark text-brand-dark font-bold tracking-wider text-xs px-6 py-6 rounded-md shadow-md hover:shadow-lg transition-all"
            >
              GET A QUOTE
            </Button>
          </div>

          {/* Mobile toggle */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            {mobileOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="lg:hidden pb-6 border-t border-white/10 pt-4">
            <nav className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="text-white text-sm font-semibold tracking-wider py-3 px-2 text-left hover:bg-white/5 hover:text-brand-yellow rounded transition-colors"
                >
                  {link.label}
                </button>
              ))}
              <a
                href="tel:07784732546"
                className="flex items-center gap-2 text-white py-3 px-2 text-sm font-bold"
              >
                <Phone size={14} className="text-brand-yellow" />
                07784 732546
              </a>
              <Button
                onClick={() => scrollTo("contact")}
                className="bg-brand-yellow hover:bg-brand-yellow-dark text-brand-dark font-bold tracking-wider text-xs mt-2"
              >
                GET A QUOTE
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
